import { Config } from '@/config';
import { StorageService } from '@/services/storage.service';
import * as sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vue from 'vue';

// Wrapper for the sentry plugin to simplify usage.
export const Sentry = Object.freeze({
  init: () => {
    if (Config.sentry) {
      sentry.init({
        dsn: Config.sentry,
        environment: Config.mode,
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
      });

      const user = StorageService.getCurrentUser();
      sentry.configureScope((scope) => {
        scope.setUser(user);
      });
    }
  },
  setUser: (user) => {
    sentry.configureScope((scope) => {
      scope.setUser(user);
    });
  },
  captureMessage: (message, extra = {}) => {
    sentry.withScope((scope) => {
      for (const [key, value] of Object.entries(extra)) {
        scope.setExtra(key, value);
      }

      sentry.captureMessage(message);
    });
  },
  captureException: (error, extra = {}) => {
    sentry.withScope((scope) => {
      for (const [key, value] of Object.entries(extra)) {
        scope.setExtra(key, value);
      }

      sentry.captureException(error);
    });
  },
});
